import { Runtime } from '@/core/enums/runtime.enum'

export const HOSTED_RUNTIME_LABEL: Record<Runtime, string> = {
  [Runtime.Nodejs]: 'Node.js',
  [Runtime.Netcore]: '.NET',
  [Runtime.Jvm]: 'JVM',
  [Runtime.Python]: 'Python',
  [Runtime.Ruby]: 'Ruby',
  [Runtime.Php]: 'PHP',
}
